<template>
  <div id="app">
    <aizi-menu />
    <router-view></router-view>
    <aizi-foot />
  </div>
</template>

<script>
const AiziMenu = () =>
  import(/* webpackChunkName: "Menu" */ "@/components/Menu.vue");
const AiziFoot = () =>
  import(/* webpackChunkName: "Foot" */ "@/components/Foot.vue");
import { mapState } from "vuex";
export default {
  name: "App",
  metaInfo() {
    return {
      title: "Aizi",
      titleTemplate: "Aizi" + " %s",
    };
  },
  components: {
    AiziMenu,
    AiziFoot
  },
  computed: mapState(["site"]),
  created() {
    this.$store.dispatch("loadSite");
    this.$store.dispatch("loadHome");
    this.$store.dispatch("loadArticles");
  },
};
</script>

<style lang="scss">
@import "node_modules/reset-css/sass/_reset";
@font-face {
  font-family: "MGR";
  src: url("./fonts/ModernGothic-Regular.woff");
  font-weight: 500;
  font-display: swap;
}
* {
  box-sizing: border-box;
  font-weight: 500;
}
:root {
  --fs: 1rem;
  --lh: calc(1.25 * 1rem);
  --bg: rgb(255, 255, 255);
  --color: rgb(0, 0, 0);
  --hover: rgb(200, 200, 200);
  @media only screen and (max-width: 768px) {
    --fs: 0.9rem;
    --lh: calc(1.25 * 0.9rem);
  }
}

a,
a:active,
a:hover,
a:visited {
  color: var(--color);
  text-decoration: none;
  transition: color 0.3s;
  &:hover {
    color: var(--hover);
  }
}

.max-w-half {
  max-width: 65ch;
  width: 100%;
  @media only screen and (max-width: 768px) {
    max-width: 100%;
  }
}

h1 {
  font-size: calc(3.5 * var(--fs));
  line-height: 1.1;
  margin-bottom: var(--lh);
  // text-transform: uppercase;
  &.nm {
    margin-bottom: 0;
  }
  @media only screen and (max-width: 768px) {
    font-size: calc(2 * var(--fs));
    line-height: 1.1;
  }
}
h2 {
  font-size: calc(1.5 * var(--fs));
  line-height: 1.25;
  margin-bottom: var(--lh);
}
p {
  margin-bottom: var(--lh);
  &.nm {
    margin-bottom: 0;
  }
}
strong {
  // font-family: "MGM";
  font-weight: bold;
}
em {
  font-style: oblique;
}
li.ol {
  list-style-type: upper-roman;
}
.image {
  margin-bottom: var(--lh);
  figcaption {
    font-size: calc(0.8 * var(--fs));
    line-height: 1.25;
  }
}
.code {
  font-family: monospace;
  padding: var(--lh);
  margin-bottom: var(--lh);
  background: rgba(0, 0, 0, 0.05);
  width: 100%;
}
.pad {
  padding: var(--lh);
}
blockquote {
  transform: translateX(calc(4 * var(--lh)));
  margin-bottom: var(--lh);
  // text-align: center;
  @media only screen and (max-width: 768px) {
    transform: translateX(0);
    padding-left: calc(4 * var(--lh));
  }
}

body,
html {
  width: 100%;
  height: 100%;
  font-size: var(--fs);
  line-height: var(--lh);
  font-family: "MGR", "PingFang SC", sans-serif;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

#app {
  width: 100%;
  height: 100%;
  main {
    width: 100%;
/*     min-height: 100vh; */
    height: auto;
    position: relative;
  }
  img {
    width: 100%;
  }
}
</style>
